import { useEffect, useState } from 'react';

type UsageMeter = Record<string, any>;

export type UsageMetrics = {
  earnings_call_usage_meter?: UsageMeter;
  financial_analyst_usage_meter?: UsageMeter;
  senior_financial_analyst_usage_meter?: UsageMeter;
  sec_filing_usage_meter?: UsageMeter;
  autonomous_ai_usage_meter?: UsageMeter;
  insight_credit_packages_usage_meter?: UsageMeter;
};

let cachedData: UsageMetrics | null = null;
let cachedPromise: Promise<UsageMetrics> | null = null;

function fetchUsageMetrics(): Promise<UsageMetrics> {
  return fetch('/profile/usage_metrics')
    .then((resp) => {
      if (!resp.ok) {
        throw new Error('Unable to load usage metrics');
      }
      return resp.json();
    })
    .then((data) => data || {});
}

export default function useProfileUsageMetrics() {
  const [data, setData] = useState<UsageMetrics | null>(cachedData);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(!cachedData);

  useEffect(() => {
    let isMounted = true;

    if (!cachedPromise) {
      cachedPromise = fetchUsageMetrics().catch((err) => {
        cachedPromise = null;
        throw err;
      });
    }

    cachedPromise
      .then((metrics) => {
        cachedData = metrics;
        if (isMounted) {
          setData(metrics);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err.message || 'Unable to load usage metrics');
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { data, error, loading };
}
